/* eslint-disable prefer-arrow-callback,no-var,comma-dangle */
(function Video(instances) {
  /* @createVideoCloseButton
   * Create close button for video for when it gets sticky on tablet/desktop
   */
  function createVideoCloseButton(playerElement) {
    div = document.createElement('div');
    div.classList.add('tc_video__close');
    let button = document.createElement('button');
    let span = document.createElement('span');
    let text = document.createTextNode('Luk');
    span.appendChild(text);
    button.appendChild(span);
    button.setAttribute('aria-label', 'Luk video');
    button.addEventListener('click', function closeVideo() {
      playerElement.classList.add('tc_video__video--hide');
    });
    div.appendChild(button);
    playerElement.appendChild(div);
  }
  /* @getVideoElementIdWithDefault
   * Helper to get or specify an id for the video element
   */
  function getVideoElementIdWithDefault(element) {
    var res = element.getAttribute('id');
    if (!res) {
      res = 'video-instance-' + Object.keys(instances).length; // eslint-disable-line prefer-template
      element.setAttribute('id', res);
    }
    return res;
  }

  /* @createVideoInstance
   * Creates an instance of the player on top of an element
   */
  function createVideoInstance(playerElement) {
    var id = getVideoElementIdWithDefault(playerElement);
    instances[id] = instances[id] || {
      // eslint-disable-line no-param-reassign
      que: [],
      player: null,
      instantiated: false,
    };

    // We've exposed a que array to the instance, to which other scripts can push functions,
    // while a player instance is being created. This allows for registering event listeners or
    // preparing function calls, asynchrnously of player instantiation.
    // After creating the instance, we will need to run the queue. immediately thereafter,
    // we will replace the que push method with an immediate function call, so that scripts
    // can keep pushing, without being aware of whether an instance has been created or not.
    // To do all this, we will need a small function caller to run all queued functions,
    // and to insert as the que push method, once the queued functions have been run.
    function que(func) {
      func();
    }

    // Make sure player is not already instantialized
    if (!instances[id].instantiated) {
      /* eslint-disable no-param-reassign */
      instances[id].instantiated = true;
      window.tv2player
        .create(playerElement)
        .then(function _created(playerInstance) {
          // Assign the player instance
          instances[id].player = playerInstance;
          // then run all queued functions
          instances[id].que.forEach(que);
          // And lastly replace the que push with an emmidiate function call
          instances[id].que = { push: que };
          /* eslint-enable no-param-reassign */

          if (window && window.performance) {
            if (performance.makeMark) {
              performance.makeMark({
                origin: 'TV2',
                domain: 'Components',
                action: 'video',
                status: 'created',
              });
            }
          }
        });
    }
  }

  // When the window.tv2player is ready
  function tv2PlayerReady() {
    Array.prototype.slice
      .apply(window.document.querySelectorAll('.tc_video__video'))
      .forEach(function _video(playerElement) {
        createVideoInstance(playerElement);
        createVideoCloseButton(playerElement);
      });
  }

  // when the dom is ready
  function domready() {
    if (!window.tv2player) {
      window.document.addEventListener('tv2player.ready', tv2PlayerReady);
    } else {
      tv2PlayerReady();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', domready);
  } else {
    domready();
  }
})((window.tv2playerInstances = window.tv2playerInstances || {}));
